import React from "react";
import { Box, Flex, Text } from "@catchoftheday/cg-components";
export const BenefitItem = ({ icon, children }) => {
    return (<Flex alignItems="center" my={2}>
      <Box flexShrink={0} color="onePass.primary" width="50px">
        {icon}
      </Box>
      <Text m={0} fontWeight="inherit">
        {children}
      </Text>
    </Flex>);
};
